import { useEffect, useState } from 'react';
import * as api from '../api/api';

const RegisterStrava = () => {
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const registerStrava = () => {
            const code = new URLSearchParams(window.location.search).get('code');
            return api.registerStrava(code);
        }
        console.log("Registering Strava");
        registerStrava().then(response => {

            console.log(response);
            // The connect request itself only exchanges the OAuth code -
            // importing the actual activities keeps running on the backend
            // after this resolves (see app.py's save_strava_registration),
            // and can take a few minutes for a full history. Record when
            // that started so the app can tell the user it's still working
            // once they land back on it, rather than looking finished with
            // no activities yet.
            localStorage.setItem('stravaImportStartedAt', String(Date.now()));
            window.location.href = window.location.origin;
        }).catch(error => {
            setErrorMessage(
                error.response?.data?.message || "Unable to register Strava"
            );
        });

    }, []);

    return (
        <div>
            <h1>Registering</h1>
            {errorMessage ? <p>{errorMessage}</p> : <p>Redirecting...</p>}
        </div>
    );
}

export default RegisterStrava;